import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Error404() {
    return <main className="homePage">
        <Helmet><title>Satkartar | Page not found</title></Helmet>
        <section className="user_card"><div className="auth-card-inner">
            <h1>Page not found</h1>
            <p>This page does not exist.</p>
            <Link to="/dashboard" className="back-login">Back to Dashboard</Link>
        </div></section>
    </main>;
}
